export const SidebarData = [
  {
    title: "Home",
    cName: "nav-text",
    link: "/",
  },
  {
    title: "Shops by Category",

    cName: "nav-text",
    link: "/electronicProducts",
  },
  {
    title: "My List",

    cName: "nav-text",
    link: "/beverages",
  },
  {
    title: "JioMart Wallet",

    cName: "nav-text",
    link: "*",
  },
  {
    title: "JioMart Gift Store",

    cName: "nav-text",
    link: "*",
  },
  {
    title: "JioMart Gift Card",

    cName: "nav-text",
    link: "*",
  },
  {
    title: "GoGreen with JioMart",

    cName: "nav-text",
    link: "*",
  },
  {
    title: "Coupon Store",

    cName: "nav-text",
    link: "*",
  },
  {
    title: "All Offers",

    cName: "nav-text",
    link: "*",
  },
];

export default SidebarData;
